import {axiosRequest} from "./apiBase";
import {Comparison} from "../common/models/compare/comparison.model";

export const getComparisonWithProfile = async (profileToCompareId: number): Promise<Comparison> => {
    return axiosRequest(
        "GET",
        `compare/profile/${profileToCompareId}`
    );
};

export const getComparisonWithCelebrity = async (celebrityToCompareId: number): Promise<Comparison> => {
    return axiosRequest(
        "GET",
        `compare/celebrity/${celebrityToCompareId}`
    );
};